<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:58:32
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-10 18:02:28
-->
<template>
  <div :style="{height:height}" class="content">
    <div class="top">
      <el-select
        v-model="valueSite"
        placeholder="请选择"
        style="width: 310px; margin-right: 20px"
      >
        <el-option
          v-for="item in selectOptions"
          :key="item.id"
          :label="item.name"
          :value="`${item.id}`"
        >
        </el-option>
      </el-select>
      <el-button @click="search" type="primary">查询</el-button>
    </div>
    <div class="data-analysis">
      <div class="total">
        <div class="item">
          <div class="cont-user">
             <img class="img" src="@/assets/images/1.png" />
            <div class="news-box">
              <div class="user-title">稿件总数</div>
              <div class="user-num">
                <span>{{ manuscriptTotal }}</span
                >个
              </div>
            </div>
            <img class="imgTwo" src="@/assets/images/01.png" />
          </div>
        </div>
        <div class="item" style="margin-left: 20px">
          <div class="cont-user">
             <img class="img" src="@/assets/images/2.png" />
            <div class="news-box">
              <div class="user-title">栏目总数</div>
              <div class="user-num">
                <span>{{ siteColumnTotal }}</span
                >个
              </div>
            </div>
              <img class="imgTwo" src="@/assets/images/02.png" />
          </div>
        </div>
        <div class="item" style="margin-left: 20px">
          <div class="cont-user">
             <img class="img" src="@/assets/images/03.png" />
            <div class="news-box">
              <div class="user-title">管理员总数</div>
              <div class="user-num">
                <span>{{ managementTotal }}</span
                >个
              </div>
            </div>
             <img class="imgTwo" src="@/assets/images/3.png" />
          </div>
        </div>
        <div class="item" style="margin-left: 20px">
          <div class="cont-user">
             <img class="img" src="@/assets/images/4.png" />
            <div class="news-box">
              <div class="user-title">用户总数</div>
              <div class="user-num">
                <span>{{ userTotal }}</span
                >个
              </div>
            </div>
            <img class="imgTwo" src="@/assets/images/04.png" />
          </div>
        </div>
      </div>
      <div class="charts">
        <div class="felB">
          <div class="felB" style="font-weight: bold">
            <div class="tab-tips"></div>
            <div>站点趋势图</div>
          </div>
          <div class="felB">
            <div
              @click="timeChange(1)"
              :class="type == 1 ? 'button-checked' : ''"
              class="button"
            >
              近七日
            </div>
            <div
              @click="timeChange(2)"
              :class="type == 2 ? 'button-checked' : ''"
              class="button"
            >
              近30日
            </div>
            <div style="width: 350px">
              <el-date-picker
                v-model="timeValue"
                type="daterange"
                @change="selectTime"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="felB">
          <div id="site-chart" class="gender-chart"></div>
          <div id="site-chart1" class="gender-chart"></div>
        </div>
        <div class="felB">
          <div class="chi-yun">
            <div
              class="felB"
              style="font-weight: bold; justify-content: flex-start"
            >
              <div class="tab-tips"></div>
              <div>词云分析</div>
            </div>
            <div class="word">
              <div id="word-cloud" class="word-cloud"></div>
            </div>
          </div>
          <div class="di-tu">
            <div class="felB" style="font-weight: bold">
              <div class="di-yu-fen">
                <div class="tab-tips"></div>
                <div>地域分布</div>
              </div>
            </div>
            <div class="region">
              <div class="zhi-biao">
                <div style="margin-bottom: 14px">显示指标 :</div>
                <a-radio-group v-model="value" @change="change">
                  <a-radio :style="radioStyle" :value="0"> 浏览量 </a-radio>
                  <a-radio :style="radioStyle" :value="1"> 访客数 </a-radio>
                  <a-radio :style="radioStyle" :value="2"> IP </a-radio>
                </a-radio-group>
              </div>
              <div class="map-box" ref="chinaMap" />
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-box">
        <div class="shou-fan">
          <div
            class="felB"
            style="font-weight: bold; justify-content: flex-start;margin-bottom:20px"
          >
            <div class="tab-tips"></div>
            <div>近7日受访页面TOP10</div>
          </div>
          <a-table :row-key="(record) => record.sort" :locale="locale" :pagination="false" width="100%" :columns="columns" :data-source="dataUrl">
              <a @click="toPath(record)" style="text-decoration:underline" slot="url" slot-scope="text,record">{{ text }}</a>
          </a-table>
        </div>
        <div class="shou-fan-gaoj">
          <div
            class="felB"
            style="font-weight: bold; justify-content: flex-start;margin-bottom:20px"
          >
            <div class="tab-tips"></div>
            <div>近7日稿件阅读量TOP10</div>
          </div>
          <a-table :row-key="(record) => record.sort" :locale="locale" :pagination="false" width="100%"  :columns="columnsTwo" :data-source="dataUrlTwo">
               <a  @click="toPath(record)" style="text-decoration:underline" slot="name" slot-scope="text,record">{{ text }}</a>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import wordcloud from "echarts-wordcloud";
import {
  findColumnManuscriptTotal,
  findManagementTotal,
  findSiteColumnTotal,
  findUserTotal,
  findSiteTrendsColumnManuscriptTotal,
  siteAccess,
  wordCloudAnalysis,
  regionalDistribution,
  list,
  urlTop,
  manuscriptTop
} from "./website_overview";
export default {
  data() {
    return {
      valueSite: '',
      manuscriptTotal: "",
      managementTotal: "",
      siteColumnTotal: "",
       maskImage:'',
      locale:{emptyText:<el-empty description="暂无数据"></el-empty>},
      userTotal: "",
      selectOptions: [],
      value: 0,
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      timeValue: "",
      type: 1,
      startTime: "",
      endTime: "",
      columns:[
        {
          title: '序号',
          dataIndex: 'sort',
           width:20,
        },
        {
          title: 'url',
          dataIndex: 'url',
           width:140,
            ellipsis: true,
          scopedSlots: { customRender: 'url' },
        },
        {
          title: '游览量(PV)',
          dataIndex: 'viewNumber',
           width:50,
        }
      ],
      columnsTwo:[
        {
          title: '序号',
          dataIndex: 'sort',
          width:20,
          ellipsis: true,
        },
        {
          title: 'url',
          dataIndex: 'name',
          width:140,
          scopedSlots: { customRender: 'name' },
          ellipsis: true,
        },
        {
          title: '游览量(PV)',
          dataIndex: 'viewNumber',
           width:50,
        }
      ],
      dataUrl:[],
      dataUrlTwo:[],
      height:0,
      myChart:'',
      myChart2:'',
      myChart3:'',
    };
  },
  mounted() {
    this.valueSite =  sessionStorage.getItem("siteId")
    this.maskImage = new Image();
     this.maskImage.src = require('../../../assets/images/yuan.png');
    if(this.valueSite){
      this.getManuscriptTotal();
    this.getManagementTotal();
    this.getSiteColumnTotal();
    this.getUserTotal();
    let startTime =
      new Date(new Date().toLocaleDateString()).getTime() -
      7 * 24 * 3600 * 1000;
    let endTime = new Date(new Date().toLocaleDateString()).getTime();
    this.startTime = this.farmatDate(startTime, "-");
    this.endTime = this.farmatDateTwo(endTime, "-");
     this.endTime = this.endTime + ' ' + '23:59:59'
    this.getSiteQuShi();
    this.getSiteFanW();
    this.getCloud();
    this.getDiyu();
    this.getList();
    this.getUrlTop();
    this.getManuscriptTop();
    }
    
     this.height = (document.documentElement.clientHeight - 110)+'px';
    window.onresize = () => {
      return (() => {
         this.height = (document.documentElement.clientHeight - 110)+'px';
         this.myChart.resize();
         this.myChart2.resize();
         this.myChart3.resize();
      })();
    };
  },
  methods: {
    toPath(item){
        window.open(item.url)
    },
    getManuscriptTop(){
        manuscriptTop({
            siteId: this.valueSite,
            startTime: this.startTime,
            endTime: this.endTime,
        }).then((res)=>{
            if(res.code == 0){
               res.data.forEach((element,index) => {
                element.sort = index + 1;
             });
                this.dataUrlTwo = res.data;
            }
        })
    },
    getUrlTop(){
      urlTop({
         siteId: this.valueSite,
          startTime: this.startTime,
          endTime: this.endTime,
      }).then((res)=>{
          if(res.code == 0){
             res.data.forEach((element,index) => {
                element.sort = index + 1;
             });
              this.dataUrl = res.data;
          }
      })
      this.dataUrl
    },
    search() {
      this.getManuscriptTotal();
      this.getManagementTotal();
      this.getSiteColumnTotal();
      this.getUserTotal();
      this.getSiteQuShi();
      this.getSiteFanW();
      this.getCloud();
      this.getDiyu();
      this.getUrlTop();
      this.getManuscriptTop();
    },
    change() {
      this.getDiyu();
    },
    getList() {
      list({}).then((res) => {
        if (res.code == 0) {
          this.selectOptions = res.data;
        }
      });
    },
    selectTime(time) {
      this.type = 3;
      if (time) {
        this.startTime = this.farmatDate(
          new Date(time[0].toString()).getTime(),
          "-"
        );
        this.endTime = this.farmatDateTwo(
          new Date(time[1].toString()).getTime(),
          "-"
        );
         this.endTime = this.endTime + ' ' + '23:59:59'
      }else{
          this.timeChange(1);
      }
      this.getSiteQuShi();
      this.getSiteFanW();
      this.getDiyu();
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    farmatDateTwo(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD;
    },
    timeChange(type) {
      this.type = type;
      if (type == 1) {
        let startTime =
          new Date(new Date().toLocaleDateString()).getTime() -
          7 * 24 * 3600 * 1000;
        let endTime = new Date(new Date().toLocaleDateString()).getTime();
        this.startTime = this.farmatDate(startTime, "-");
        this.endTime = this.farmatDateTwo(endTime, "-");
        this.endTime = this.endTime + ' ' + '23:59:59'
      } else {
        let startTime =
          new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000;
        let endTime = new Date(new Date().toLocaleDateString()).getTime();
        this.startTime = this.farmatDate(startTime, "-");
        this.endTime = this.farmatDateTwo(endTime, "-");
        this.endTime = this.endTime + ' ' + '23:59:59'
      }
      this.getSiteQuShi();
      this.getSiteFanW();
      this.getDiyu();
    },
    getDiyu() {
      regionalDistribution({
        siteId: this.valueSite,
        startTime: this.startTime,
        endTime: this.endTime,
        type: this.value,
      }).then((res) => {
        if (res.code == 0) {
          let array = [];
          res.data.forEach((element) => {
            array.push({
              name: element.city,
              value: element.number,
            });
          });
          let map = this.$echarts.init(this.$refs.chinaMap);
          let options = this.mapChinaOptions(array);
          map.setOption(options);
        }
      });
    },
    getCloud() {
       let startTime = new Date(new Date().toLocaleDateString()).getTime() - 7 * 24 * 3600 * 1000;
        let endTime = new Date(new Date().toLocaleDateString()).getTime();
        startTime = this.farmatDate(startTime, "-");
        endTime = this.farmatDateTwo(endTime, "-");
        endTime = endTime + ' ' + '23:59:59'
      wordCloudAnalysis({
          siteId: this.valueSite,
          startTime: startTime,
          endTime: endTime,
      }).then((res) => {
        if (res.code == 0) {
          let array = [];
          res.data.forEach((element) => {
            array.push({
              value: element.number,
              name: element.text,
            });
          });
          let wordOption = {
             series: [{
                      type: 'wordCloud',
                      shape: 'circle',
                      rotationRange: [0,0],
                      sizeRange: [12, 50],
                      gridSize: 10,
                      width: "130%",
                      height: "130%",
                      maskImage: this.maskImage,
                      textStyle: {
                      normal: {
                            fontFamily: 'sans-serif',
                                color: function () {
                                    return 'rgb(' + [
                                        Math.round(Math.random() * 160),
                                        Math.round(Math.random() * 160),
                                        Math.round(Math.random() * 160)
                                    ].join(',') + ')';
                                }
                            },
                            emphasis: {
                                shadowBlur: 10,
                                shadowColor: '#333'
                            }
                        },
                        data:array,
              }]
          };
          var chartDom3 = document.getElementById("word-cloud");
          this.myChart3 = echarts.init(chartDom3);
          wordOption &&  this.myChart3.setOption(wordOption);
        }
      });
    },
    getSiteFanW() {
      siteAccess({
        siteId: this.valueSite,
        startTime: this.startTime,
        endTime: this.endTime,
      }).then((res) => {
        if (res.code == 0) {
          let timeArray = [];
          let columnIp = [];
          let viewNumber = [];
          let userNumber = [];
          res.data.forEach((element) => {
            timeArray.push(element.time);
            columnIp.push(element.ipNumber);
            viewNumber.push(element.viewNumber);
            userNumber.push(element.userNumber);
          });
         let option2 = {
                  legend: {
                    bottom: -5,
                    data: ["游览量", "访客数","IP"],
                  },
                  tooltip: {
                    trigger: "axis",
                    axisPointer: {
                      type: "cross",
                      label: {
                        backgroundColor: "#6a7985",
                      },
                    },
                  },
                  dataZoom: [{
                    type: 'slider',
                    show: true, //flase直接隐藏图形
                    xAxisIndex: [0],
                    left: '10%', //滚动条靠左侧的百分比
                    bottom: 25,
                    start: 0,//滚动条的起始位置
                    end: 50//滚动条的截止位置（按比例分割你的柱状图x轴长度）
                  }],
                  grid: {
                     left: "3%",
                      right: "16%",
                      bottom: "20%",
                      containLabel: true,
                  },
                  xAxis: {
                    data: timeArray,
                  },
                  yAxis: {},
                  series: [
                    {
                      data: viewNumber,
                      type: "line",
                      name: '游览量',
                      itemStyle: {
                        normal: {
                          color: "#9ac9c0",
                          lineStyle: {
                            color: "#9ac9c0"
                          }
                        }
                      },
                      areaStyle: {
                        color: "#9ac9c0",
                        opacity: 0.5,
                      },
                    },
                    {
                      data: userNumber,
                      type: "line",
                      name: '访客数',
                      itemStyle: {
                        normal: {
                          color: "#d0e7e8",
                          lineStyle: {
                            color: "#d0e7e8"
                          }
                        }
                      },
                      areaStyle: {
                        color: "#d0e7e8",
                        opacity: 0.5,
                      },
                    },
                    {
                      data: columnIp,
                      type: "line",
                      name: 'IP',
                      itemStyle: {
                        normal: {
                          color: "#c8e0ef",
                          lineStyle: {
                            color: "#c8e0ef"
                          }
                        }
                      },
                      areaStyle: {
                        color: "#c8e0ef",
                        opacity: 0.5,
                      },
                    },
                  ],
                };
          var chartDom2 = document.getElementById("site-chart1");
          this.myChart2 = echarts.init(chartDom2);
          option2 &&  this.myChart2.setOption(option2);
        }
      });
    },
    getSiteQuShi() {
      findSiteTrendsColumnManuscriptTotal({
        siteId: this.valueSite,
        startTime: this.startTime,
        endTime: this.endTime,
      }).then((res) => {
        if (res.code == 0) {
          let timeArray = [];
          let columnNum = [];
          let manuscriptNum = [];
          res.data.forEach((element) => {
            timeArray.push(element.day);
            columnNum.push(element.columnNum);
            manuscriptNum.push(element.manuscriptNum);
          });
          let option = {
                  legend: {
                    bottom: -5,
                    data: ["稿件发布数", "栏目更新数"],
                  },
                  tooltip: {
                    trigger: "axis",
                    axisPointer: {
                      type: "cross",
                      label: {
                        backgroundColor: "#6a7985",
                      },
                    },
                  },
                  dataZoom: [{
                    type: 'slider',
                    show: true, //flase直接隐藏图形
                    xAxisIndex: [0],
                    left: '10%', //滚动条靠左侧的百分比
                    bottom: 25,
                    start: 0,//滚动条的起始位置
                    end: 50//滚动条的截止位置（按比例分割你的柱状图x轴长度）
                  }],
                  grid: {
                     left: "3%",
                      right: "16%",
                      bottom: "20%",
                      containLabel: true,
                  },
                  xAxis: {
                    data: timeArray,
                  },
                  yAxis: {},
                  series: [
                    {
                      data: manuscriptNum,
                      type: "line",
                      name: '稿件发布数',
                      itemStyle: {
                        normal: {
                          color: "#c8dfef",
                          lineStyle: {
                            color: "#c8dfef"
                          }
                        }
                      },
                      areaStyle: {
                        color: "#c8dfef",
                        opacity: 0.5,
                      },
                    },
                    {
                      data: columnNum,
                      type: "line",
                      name: '栏目更新数',
                      itemStyle: {
                        normal: {
                          color: "#d4e9ec",
                          lineStyle: {
                            color: "#d4e9ec"
                          }
                        }
                      },
                      areaStyle: {
                        color: "#d4e9ec",
                        opacity: 0.5,
                      },
                    },
                  ],
                };
          var chartDom = document.getElementById("site-chart");
          this.myChart = echarts.init(chartDom);
          option &&  this.myChart.setOption(option);
        }
      });
    },
    getManuscriptTotal() {
      findColumnManuscriptTotal({
        siteId: this.valueSite,
      }).then((res) => {
        if (res.code == 0) {
          this.manuscriptTotal = res.data.num;
        }
      });
    },
    getManagementTotal() {
      findManagementTotal({ siteId: this.valueSite }).then((res) => {
        if (res.code == 0) {
          this.managementTotal = res.data.num;
        }
      });
    },
    getSiteColumnTotal() {
      findSiteColumnTotal({ siteId: this.valueSite }).then((res) => {
        if (res.code == 0) {
          this.siteColumnTotal = res.data.num;
        }
      });
    },
    getUserTotal() {
      findUserTotal({ siteId: this.valueSite }).then((res) => {
        if (res.code == 0) {
          this.userTotal = res.data.num;
        }
      });
    },
    mapChinaOptions(data, formatter) {
      return {
        visualMap: {
          show: false,
          min: 0,
          max: 100000000,
          // inRange: {
          //     color: ['#fae8e9', '#f7a8be', '#f1658b ', '#CB000C']
          // },
        },
        // 暂且不知道做啥子用的
        // geo: {
        //     map: 'china',
        //     // layoutCenter:['10%','5%'],
        //     // center: [104.114129, 35.950339],
        // },
        grid: {
          top: 10,
          bottom: 10,
          width: "500px",
          height: "500px",
        },
        tooltip: {
          trigger: "item",
          formatter: formatter ? formatter : "{b}<br/>{c}",
          borderColor: "#CB000C",
          borderWidth: "1",
        },
        dataRange: {
          // 数值范围对应的 取色
          x: "left",
          y: "bottom",
          show: false,
          splitList: [
            { start: 20000, color: "#CB000C" },
            { start: 10001, end: 20000, color: "#f1658b" },
            { start: 5001, end: 10000, color: "rgba(247,168,190,.8)" },
            { end: 5000, color: "#fae8e9" },
          ],
          color: ["#fae8e9", "#f7a8be", "#f1658b ", "#CB000C"],
        },
        series: [
          {
            type: "map",
            map: "china",
            itemStyle: {
              areaColor: "#8dc9fe", //地图的颜色
              borderColor: "rgba(60,70,88,.5)", //边界线颜色
              borderWidth: ".5", //边界线宽
              emphasis: {
                // 对应的鼠标悬浮效果
                color: "#FF0000",
                areaColor: "#CB000C",
                borderColor: "#FFF",
                borderWidth: 1,
              },
            },
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                if (params.value) {
                  return params.name + " : " + params.value;
                } else {
                  return params.name + " : " + "0";
                }
              },
            },
            label: {
              fontSize: 12,
              normal: {
                show: true, // 默认 是否显示省份标签
                color: "#000",
              },
              emphasis: {
                show: true, // 鼠标 hover 时是否显示身份标签
                textStyle: {
                  color: "#fff",
                },
              },
            },
            data: data,
          },
        ],
      };
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  // padding: 20px 30px;
  background: #fff !important;
  overflow: auto;
  .top {
    padding: 20px 30px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #f7f7f7;
    /deep/.el-input__inner {
      background-color: rgba(245, 247, 250, 1);
      height: 40px;
    }
  }

  .data-analysis {
    padding: 20px 30px;
    .total {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      .item {
        background: #f7f7f7;
        width: 270px;
        height: 76px;
        padding-left: 30px;
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: bold;
        span {
          font-size: 20px;
        }
      }
    }
    .felB {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top:30px;
    }
    .charts {
      .tab-tips {
        width: 6px;
        height: 16px;
        background: #1890ff;
        margin-right: 8px;
      }
      /deep/.el-date-editor .el-range-separator {
        width: 10%;
      }
      .button {
        border: #dbd8d8 1px solid;
        border-radius: 6px;
        color: #dbd8d8;
        width: 60px;
        height: 34px;
        line-height: 34px;
        box-sizing: border-box;
        text-align: center;
        font-weight: normal;
        margin-right: 10px;
        cursor: pointer;
      }
      .button-checked {
        border: #1890ff 1px solid;
        color: #1890ff;
      }
      .gender-chart {
        width: 75vh;
        height: 320px;
      }
      .word {
        width: 340px;
        height: 340px;
        border: #dbd8d8 1px solid;
        padding: 30px;
        margin-top: 20px;
        .word-cloud {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .region {
        border: #dbd8d8 1px solid;
        padding: 5px;
        margin-top: 20px;
        margin-left: 24px;
        display: flex;
      }
    }
  }
}
.map-box {
 flex: 1;
  height: 350px;
  margin-top: -20px;
}
.chi-yun {
  width: 350px;
}
.di-tu {
  flex: 1;
}
.zhi-biao {
  width: 200px;
  padding-top: 40px;
  padding-left: 40px;
}
.di-yu-fen {
  display: flex;
  margin-left: 24px;
  align-items: center;
}

.cont-user {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  img{
    width: 50px;
    height: 50px;
    margin-right: 5px;
  }
  .imgTwo{
       width: 30px;
      height: 35px;
      position: absolute;
      bottom: 5px;
      right: 8px;
  }
}
.news-box {
  width: 116px;
  .user-title {
    color: rgba(96, 98, 102, 1);
  }
}
.tab-tips {
  width: 6px;
  height: 16px;
  background: #1890ff;
  margin-right: 8px;
}
.bottom-box {
  margin-top: 24px;
  display: flex;
  margin-bottom: 40px;
  /deep/ .ant-table{
    border: 1px solid rgba(220, 223, 230, 1);
  }
  /deep/ .ant-table-column-title{
    color: rgba(16, 16, 16, 1);
    font-weight: 600;
  }
  .shou-fan{
    flex: 1;
  }
  .shou-fan-gaoj{
    flex: 1;
    margin-left: 24px;
  }
}
.el-select{
    background-color: rgba(245, 247, 250, 1);
}
.el-button--primary {
  background: #176de6;
}
/deep/ .ant-table-tbody > tr > td{
    padding: 9.5px 16px;
    color: #303133;
}
/deep/ .ant-table-thead > tr > th{
   padding: 12.5px 16px;
}
/deep/ .ant-table-fixed-left{
  border-right: 1px solid rgba(228, 231, 237, 1);
}
/deep/ .ant-table-fixed-right{
    border-left: 1px solid rgba(228, 231, 237, 1);
    
}
/deep/ .ant-table-fixed-right .ant-table-tbody > tr > td{
   padding: 9.5px 24px;
}
/deep/ .ant-table-fixed-right .ant-table-thead > tr:first-child > th:last-child{
  padding: 12.5px 24px;
  
}
/deep/ .ant-table-thead > tr > th{
    background-color: rgba(245, 247, 250, 1);
}
/deep/ .ant-table-thead > tr{
   background-color: rgba(245, 247, 250, 1);
}
/deep/ .ant-table-hide-scrollbar{
  background-color: rgba(245, 247, 250, 1);
  
}
/deep/ .ant-table-column-title{
    color: #606266;
}
/deep/ .ant-table-fixed-left table,.ant-table-fixed-right table{
    width: min-content;
    }
    /deep/ .ant-table-row-cell-ellipsis {
      max-width: 1px !important;
      overflow: hidden !important;
      white-space: nowrap !important;
      -o-text-overflow: ellipsis !important;
      text-overflow: ellipsis !important;
  }

  /deep/ .el-empty__description p{
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    text-align: left;
    font-family: Roboto-regular;
  }
  /deep/ .el-empty{
    padding: 11px 0px 15px 0px;
  }
  /deep/ .el-empty__description{
    margin-top: 10px;
  }
  /deep/ .ant-table-placeholder{
    border-bottom: none;
  }

   /deep/ tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background:#fafafa !important;
  }
  /deep/ tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{
    background:#fafafa !important;
  }
  /deep/ .ant-table-tbody > tr:last-child > td{
      border-bottom: none;
  }
</style>